import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs";
import { AuthProvider } from "../../providers/auth/auth";
import * as _ from "lodash";
import * as moment from "moment";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import firebase from "firebase/app";
import { AngularFirestore } from "angularfire2/firestore";
import { AdminPrescriptionUpdatePage } from "../admin-prescription-update/admin-prescription-update";

@IonicPage()
@Component({
  selector: "page-admin-prescriptions",
  templateUrl: "admin-prescriptions.html"
})
export class AdminPrescriptionsPage {
  public preList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;
  status: string = "All";
  user_id: string;
  display_name: string;

  gridApi: any;
  columnDefs: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private iab: InAppBrowser,
    private afs: AngularFirestore,
    private modalCtrl: ModalController
  ) {
    this.auth.getCurrentUser().then(user => {
      this.user_id = user.id;
      this.display_name = user.display_name;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.columnDefs = [
        { headerName: "Clinic", field: "clinic_name" },
        {
          headerName: "Patient",
          valueGetter: function getStatus(params) {
            if(user.roles.clinic_tester) {
              return "-------------";
            }
            else if(user.roles.opteva_admin) {
              return params.data.patient.full_name;
            }
            else {
              return params.data.patient.full_name;
            }
          }
        },
        { headerName: "Doctor", field: "doctor.full_name" },
        {
          headerName: "Date",
          valueGetter: function getMeds(params) {
            return moment(params.data.createdAt.toDate()).format("MMM DD YYYY h:mm A") // 27 January 10:30 am
          }
        },
        {
          headerName: "Drug",
          valueGetter: function getMeds(params) {
            return _.map(params.data.medication, "name").join(", ");
          }
        },
        { headerName: "Status", field: "status" }
      ];

      this.getPrescriptions();
    });
  }

  ionViewDidLoad() {}


  public formatDate(date) {
    let myMoment: moment.Moment;
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("MMM DD YYYY");
  }

  public getPrescriptions() {
    let status: string = null;
    if (this.status !== "All") {
      status = this.status;
    }

    this.preList = this.afs
      .collection("prescriptions", ref => {
        let query:
          | firebase.firestore.CollectionReference
          | firebase.firestore.Query = ref;
        if (status) {
          query = query.where("status", "==", status);
        }
        return query.orderBy("createdAt", "desc");
      })
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          //console.log(data);
          data["doctor"]["full_name"] =
            data["doctor"]["first_name"] + " " + data["doctor"]["last_name"];
          return data;
        });
      });
  }

  segmentChanged(ev) {
    this.getPrescriptions();
    //this.statusFilter$.next("Completed");
  }

  openPrescriptionImage(imageUrl) {
    let browser = this.iab.create(imageUrl, "_blank", {
      closebuttoncaption: "Exit",
      enableViewportScale: "yes"
    });
  }


  onCellClicked(ev) {
    console.log(ev)
    const prescription = ev.data;
    // this.updateStatus(null, prescription);
    this.updatePrescription(prescription);
  }

  updateStatus(status, prescription) {
    console.log("Prescription: ", prescription);
    if (status === "Queued") {
      this.database.updatePrescriptionAndStudies(
        status,
        null,
        prescription.id,
        prescription.clinic_id,
        prescription.patient.id,
        this.user_id,
        this.display_name,
        []
      );
    } else {
      
      const alert = this.alertCtrl.create({

      title: "Change Status",
        inputs: [
          {
            type: 'radio',
            label: 'Queued',
            value: 'Queued',
            checked: prescription.status === 'Queued'
          },
            {
              type: 'radio',
              label: 'Fulfilled',
              value: 'Fulfilled',
              checked: prescription.status === 'Fulfilled'
            },
            {
              type: 'radio',
              label: 'On Hold',
              value: 'On Hold',
              checked: prescription.status === 'On Hold'
            },
            {
              type: 'radio',
              label: 'Cancelled',
              value: 'Cancelled',
              checked: prescription.status === 'Cancelled'
            }
        ],
        buttons: [
          {
            text: "Update",
            role: "submit",
            handler: data => {
              console.log(data)
              this.database.updatePrescriptionAndStudies(
                data,
                null,
                prescription.id,
                prescription.clinic_id,
                prescription.patient.id,
                this.user_id,
                this.display_name,
                []
              );
            }
          },
          {
            text: "Cancel",
            role: "cancel",
            handler: data => console.log("Cancel clicked")
          }
        ]
      });
      alert.present();


    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    // this.gridApi.sizeColumnsToFit();
  }

  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }

  createStudyEnrolment(script)  {
    
    let study: any = {};
    study.Renewed = false;

    study.agreement = {};
    study.createdAt = script.createdAt;
    study.updatedAt = script.createdAt;
    study.agreement.consent_name = null;
    study.agreement.consent_signature = null;
    study.agreement.signatory_name = null;
    study.agreement.signature = null;

    study.clinic_id = script.clinic_id;
    study.clinic_name = script.clinic_name;
    study.completed = false;
    study.doctor = script.doctor;
    study.doctor_id = script.doctor_id;
    study.patient = script.patient;
    study.speedscore = null;
    study.study = [];
    study.study.push(script.studies[0]);
    study.study_id_last = null;

    console.log("Study Data: ", study);
    this.database.createStudy(script.clinic_id, script.patient_id, study, null);
  }

  updatePrescription(prescription)  {
    let rxModal = this.modalCtrl.create(AdminPrescriptionUpdatePage, {'rxData': prescription} , {showBackdrop: true, enableBackdropDismiss: false});
    rxModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-prescriptions/admin-prescriptions.ts